

















































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import MaterialGroupApi from "@/services/MaterialGroups";
import CategoriesApi from "@/services/CategoriesApi";
import { Category, MaterialGroupList, NewMaterialGroup, Plan, UpdateMaterialGroup } from "@/api/lab-base-api-client";
import MaterialGroupModule from "@/store/materialGroup";
import CategoryModule from "@/store/category";
import UgcsApi from "@/services/Ugcs";
import StripeApi from "@/services/StripeApi";
import { ValidationObserver } from "vee-validate";
import { generateFileReader } from "@/utils/Util";
import logger from "@/lib/log/logger";

@Component
export default class MMaterialRegisterContent extends Vue {
  // materialGroup一覧
  private materialGroups: MaterialGroupList[] = [];

  // category一覧
  private categories: Category[] = [];

  // imgのinput初期値
  private image = [];

  private plans: Plan[] = [];

  // imgPreviewのurl
  private ugcUrl = "";

  private categoryId: number | null = null;

  // 削除・編集の対象materialGroupUuid
  private materialGroupUuid = "";

  // inputの初期値
  private items: NewMaterialGroup = {
    name: "",
    ugcUuid: undefined,
    categories: [{ id: undefined }],
    planId: "",
    visibilityFlag: false,
  };

  private editItems: UpdateMaterialGroup = {
    name: "",
    ugcUuid: undefined,
    categories: [{ id: undefined }],
    planId: "",
  };

  // items,editItemsの初期化用
  private defaultItems: NewMaterialGroup = {
    name: "",
    ugcUuid: undefined,
    categories: [{ id: undefined }],
    planId: "",
    visibilityFlag: false,
  };

  // ugcの登録確認
  private hasImage = "";

  // ダイアログ
  private isCreateDialog = false;

  private isEditDialog = false;

  private isDeleteDialog = false;

  // 選択中のcategoryIdを取得
  private get isCategoryId() {
    return CategoryModule.categoryId;
  }

  // materialGroupsのcheckboxからmaterialGroupUuidを取得
  public getMaterialGroupUuid(event: string) {
    MaterialGroupModule.changeMaterialGroupUuid(event);
  }

  public resetCategoryId(event: number) {
    CategoryModule.resetCategoryId(event);
  }

  // ページ読み込み時に実行
  private async mounted() {
    if (this.isCategoryId !== 0) {
      this.resetCategoryId(0);
    }
    await this.fetchEdit();
    await this.fetchPlans();
  }

  // プランの取得
  private async fetchPlans() {
    const plansRes = await StripeApi.instance.allGetPlan();
    if (!plansRes.data.data) {
      return;
    }
    this.plans = plansRes.data.data;
  }

  // 教材編集だった場合、categoryの一致するmaterialGroup一覧を取得
  private async fetchEdit() {
    if (this.$route.name === "MaterialEdit") {
      const MaterialGroupRes = await MaterialGroupApi.instance.getMaterialGroup();
      const MaterialGroups = MaterialGroupRes.data.data.items.filter(
        (materialGroup: { categories: {} }) => materialGroup.categories
      );
      this.materialGroupUuid = this.$route.params.content;
      this.categoryId = Number(this.$route.query.cat);

      MaterialGroups.forEach((materialGroup: MaterialGroupList) => {
        // カテゴリ-の数分回す
        for (let i = 0; i < materialGroup.categories.length; i += 1) {
          // カテゴリーidとqueryのidが同一かつmaterialsが一つ以上あれば
          if (materialGroup.categories[i].id === this.categoryId && materialGroup) {
            this.materialGroups.push(materialGroup);
          }
        }
      });
    }
  }

  @Watch("isCategoryId")
  // categoryと一致するmaterialGroup一覧取得
  private async fetch(id: number | null) {
    if (id !== 0) {
      const MaterialGroupRes = await MaterialGroupApi.instance.getMaterialGroup();
      const MaterialGroups = MaterialGroupRes.data.data.items.filter(
        (materialGroup: { categories: {} }) => materialGroup.categories
      );
      this.categoryId = id;
      this.materialGroupUuid = "";
      this.materialGroups = [];

      MaterialGroups.forEach((materialGroup: MaterialGroupList) => {
        // カテゴリ-の数分回す
        for (let i = 0; i < materialGroup.categories.length; i += 1) {
          // カテゴリーidとqueryのidが同一かつmaterialsが一つ以上あれば
          if (materialGroup.categories[i].id === id) {
            this.materialGroups.push(materialGroup);
          }
        }
      });
    }
  }

  /**
   * v-file-inputで選択したimageのプレビューを表示
   * 公式でchangeイベントの型はFile[]だが、ここでは単一のファイルしか使用しないためFileとして定義する
   */
  private previewFile(file: File) {
    if (!file) {
      this.ugcUrl = "";
    }
    const reader = generateFileReader(file);
    if (reader) {
      reader.addEventListener("load", () => {
        if (reader.result instanceof ArrayBuffer) {
          this.ugcUrl = reader.result.toString();
        } else if (reader.result) {
          this.ugcUrl = reader.result;
        }
      });
    }
  }

  // 「NEW ITEM」クリックで実行
  private async onCreateItem() {
    const categoriesRes = await CategoriesApi.instance.getCategories();
    if (!categoriesRes.data.data.categories) {
      return;
    }
    this.categories = categoriesRes.data.data.categories;
    this.isCreateDialog = true;
  }

  // Createダイアログの[ok」クリックで実行
  private async CreateItem() {
    // ベーシックプランの場合a
    if (typeof this.items.planId === "number") {
      this.items.planId = "";
    }
    await this.createMaterialGroup();
    await this.closeCreateDialog();
    await this.fetch(this.categoryId);
  }

  // Ugc作成
  private async createUgc() {
    try {
      const ugcRes = await UgcsApi.instance.createUGC(this.image);
      if (ugcRes.data.data?.ugc?.uuid === undefined) {
        logger.frontError("failed create ugc");
        throw new Error("failed create ugc");
      }
      return ugcRes.data.data.ugc;
    } catch (err) {
      if (err instanceof Error) {
        logger.frontError(`${err.name}: ${err.message}`);
        console.log(err);
      }
      throw err;
    }
  }

  // コンテンツを作成
  private async createMaterialGroup() {
    try {
      if (this.image && this.image.length === undefined) {
        const ugc = await this.createUgc();
        this.items.ugcUuid = ugc.uuid;
      }

      await MaterialGroupApi.instance.createMaterialGroup(this.items);
    } catch (err) {
      if (err instanceof Error) {
        logger.frontError(`${err.name}: ${err.message}`);
        console.log(err);
      }
    }
  }

  // Createダイアログを閉じる
  private closeCreateDialog() {
    this.isCreateDialog = false;
    this.items = { ...this.defaultItems };
    this.image = [];
    this.ugcUrl = "";
    (this.$refs.observer as InstanceType<typeof ValidationObserver>).reset();
  }

  // 「EDIT ITEM」クリックで実行
  private async onEditItem() {
    const categoriesRes = await CategoriesApi.instance.getCategories();
    if (categoriesRes.data.data.categories) {
      this.categories = categoriesRes.data.data.categories;
    }

    const materialGroupsRes = await MaterialGroupApi.instance.getMaterialGroupByUuid(this.materialGroupUuid);
    this.editItems.name = materialGroupsRes.data.data?.materialGroup?.name;
    this.editItems.ugcUuid = materialGroupsRes.data.data?.materialGroup?.ugcUuid;
    this.editItems.planId = materialGroupsRes.data.data?.materialGroup?.planId;
    this.editItems.visibilityFlag = materialGroupsRes.data.data?.materialGroup?.visibilityFlag;
    if (this.editItems.planId === null || this.editItems.planId === "") {
      this.editItems.planId = "basic";
    }

    if (this.editItems.categories) {
      this.editItems.categories[0].id = materialGroupsRes.data.data?.materialGroup?.categories[0].id;
    }
    if (this.editItems.ugcUuid !== null) {
      this.hasImage = materialGroupsRes.data.data.materialGroup.ugc.url;
    } else {
      this.hasImage = "";
    }

    this.isEditDialog = true;
  }

  // Editダイアログの「ok」クリックで実行
  private async editItem() {
    if (this.image && this.image.length === undefined) {
      const ugc = await this.createUgc();
      this.editItems.ugcUuid = ugc.uuid;
    }
    // ベーシックプランの場合
    if (this.editItems.planId === "basic") {
      this.editItems.planId = "";
    }

    await this.updateMaterialGroup();
    this.closeEditDialog();
    await this.fetch(this.categoryId);
  }

  // コンテンツ更新
  private async updateMaterialGroup() {
    try {
      await MaterialGroupApi.instance.updateMaterialGroupByUuId(this.materialGroupUuid, this.editItems);
    } catch (err) {
      if (err instanceof Error) {
        logger.frontError(`${err.name}: ${err.message}`);
        console.log(err);
      }
    }
  }

  // Editダイアログを閉じる
  private closeEditDialog() {
    this.isEditDialog = false;
    this.materialGroupUuid = "";
    this.image = [];
    this.ugcUrl = "";
    (this.$refs.observer as InstanceType<typeof ValidationObserver>).reset();
  }

  // 「Delete」クリックで実行
  private async onDeleteItem() {
    if (!this.materialGroupUuid) {
      return;
    }
    this.isDeleteDialog = true;
  }

  // Deleteダイアログの[ok」クリックで実行
  private async deleteItem() {
    await this.deleteMaterialGroup();
    this.closeDeleteDialog();
    await this.fetch(this.categoryId);
  }

  // コンテンツを削除
  private async deleteMaterialGroup() {
    try {
      await MaterialGroupApi.instance.deleteMaterialGroupById(this.materialGroupUuid);
    } catch (err) {
      if (err instanceof Error) {
        logger.frontError(`${err.name}: ${err.message}`);
        console.log(err);
      }
    }
  }

  // Deleteダイアログを閉じる
  private closeDeleteDialog() {
    this.isDeleteDialog = false;
    this.materialGroupUuid = "";
  }
}
